import React, { Fragment, useEffect, useState } from 'react';
import {
  Container,
  ContentContainer,
  InboxContainer,
  NoDataTitle,
  Buttons,
  ButtonReject,
  ButtonAccept,
  RejectedTitle,
  LastTableItem,
  IconDiv,
  TableItemCenter,
  FirstItem,
} from './NotificationsPage.styles';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import { ReactComponent as RightChevron } from '../../assets/icons/chevronRight.svg';
import { ReactComponent as Payment } from '../../assets/icons/paymentnoti.svg';
import { ReactComponent as Customer } from '../../assets/icons/customer.svg';
import { ReactComponent as Appointment } from '../../assets/icons/appointmentNotification.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getAllNotifications, markNotificationsAsSeen } from '../../store/slice/notification/asyncThunks';
import {
  selectAcceptClientRequestPending,
  selectGetAllNotificationsPending,
  selectNotifications,
  selectRejectClientRequestPending,
} from '../../store/slice/notification/slice';
import { Waveform } from '@uiball/loaders';
import { NOTIFICATION_STATUS, NOTIFICATION_TYPE } from '../../utils/constants';
import { acceptClientRequest, rejectClientRequest } from '../../store/slice/vendor/asyncThunks';
import { notifyError, notifyInfo } from '../../utils/notify';
import { acceptClientPayment, rejectPaymentForClient } from '../../store/slice/payment/asyncThunks';
import { acceptClientAppointment, rejectClientAppointment } from '../../store/slice/appointment/asyncThunks';
import {
  selectAcceptClientAppointmentPending,
  selectRejectClientAppointmentPending,
} from '../../store/slice/appointment/slice';
import HamburgerSidebar from '../../components/HamburgerSidebar/HamburgerSidebar';
import Table from '../../components/Table/Table';
import {
  selectAcceptClientRequestPaymentPending,
  selectRejectClientRequestPaymentPending,
} from '../../store/slice/payment/slice';
import { TableBodyRow } from '../../components/Table/Table.styles';
import { acceptClientDeleteRequest, rejectContractDeleteRequest } from '../../store/slice/wedding/asyncThunks';
import {
  selectAcceptClientDeleteRequestPending,
  selectRejectContractDeleteRequestPending,
} from '../../store/slice/wedding/slice';

const NotificationsPage = () => {
  const dispatch = useDispatch();
  let [searchParams] = useSearchParams();
  const pageParam = searchParams.get('page');

  const [clickedItemId, setClickedItemId] = useState('');

  const navigate = useNavigate();

  const { data, total, perPage } = useSelector(selectNotifications);
  const getAllNotificationsPending = useSelector(selectGetAllNotificationsPending);
  const rejectClientRequestPending = useSelector(selectRejectClientRequestPending);
  const acceptClientRequestPending = useSelector(selectAcceptClientRequestPending);
  const acceptClientAppointmentPending = useSelector(selectAcceptClientAppointmentPending);

  const acceptClientRequestPaymentPending = useSelector(selectAcceptClientRequestPaymentPending);
  const rejectClientRequestPaymentPending = useSelector(selectRejectClientRequestPaymentPending);
  const rejectClientAppointmentPending = useSelector(selectRejectClientAppointmentPending);
  const acceptClientDeleteRequestPending = useSelector(selectAcceptClientDeleteRequestPending);
  const rejectContractDeleteRequestPending = useSelector(selectRejectContractDeleteRequestPending);

  const changePage = page => {
    navigate({
      pathname: '/notifications',
      search: `&page=${page}`,
    });

    dispatch(getAllNotifications(page));
  };

  useEffect(() => {
    dispatch(getAllNotifications(pageParam));
  }, [dispatch, pageParam]);

  useEffect(() => {
    dispatch(markNotificationsAsSeen());
  }, [dispatch]);

  const handleAcceptRequest = (id, notificationId) => {
    setClickedItemId(notificationId);
    dispatch(acceptClientRequest({ id, notificationId }))
      .unwrap()
      .then(() => {
        setClickedItemId('');
        notifyInfo('Request accepted successfully');
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleRejectRequest = (id, notificationId) => {
    setClickedItemId(notificationId);
    dispatch(rejectClientRequest({ id, notificationId }))
      .unwrap()
      .then(() => {
        setClickedItemId('');
        notifyInfo('Request rejected successfully');
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleAcceptPayment = (notificationId, paymentId) => {
    setClickedItemId(notificationId);
    dispatch(acceptClientPayment({ paymentId, notificationId }))
      .unwrap()
      .then(() => {
        setClickedItemId('');
        notifyInfo('Payment accepted successfully');
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleRejectPayment = (notificationId, paymentId) => {
    setClickedItemId(notificationId);
    dispatch(rejectPaymentForClient({ notificationId, paymentId }))
      .unwrap()
      .then(() => {
        setClickedItemId('');
        notifyInfo('Payment rejected successfully');
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleAcceptAppointment = (appointmentId, notificationId) => {
    setClickedItemId(notificationId);
    dispatch(acceptClientAppointment({ appointmentId, notificationId }))
      .unwrap()
      .then(() => {
        setClickedItemId('');
        notifyInfo('Appointment accepted successfully');
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleRejectAppointment = (appointmentId, notificationId) => {
    setClickedItemId(notificationId);
    dispatch(rejectClientAppointment({ appointmentId, notificationId }))
      .unwrap()
      .then(() => {
        setClickedItemId('');
        notifyInfo('Appointment rejected successfully');
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleAcceptDeleteRequest = (userId, notificationId) => {
    setClickedItemId(notificationId);
    dispatch(acceptClientDeleteRequest({ id: userId, body: { notificationId } }))
      .unwrap()
      .then(() => {
        setClickedItemId('');
        notifyInfo('Delete request accepted successfully');
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleRejectDeleteRequest = notificationId => {
    setClickedItemId(notificationId);
    dispatch(rejectContractDeleteRequest({ notificationId }))
      .unwrap()
      .then(() => {
        setClickedItemId('');
        notifyInfo('Delete request rejected successfully');
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleNavigate = (type, clientId) => {
    if (type === NOTIFICATION_TYPE.PAYMENT_CREATED) {
      navigate({
        pathname: `/clients`,
        search: `?screen=details&id=${clientId}&tab=payments`,
      });
    } else if (type === NOTIFICATION_TYPE.APPOINTMENT_CREATED) {
      navigate({
        pathname: `/clients`,
        search: `?screen=details&id=${clientId}&tab=appointments`,
      });
    } else if (type === NOTIFICATION_TYPE.REQUEST_SENT || type === NOTIFICATION_TYPE.REQUEST_ACCEPTED) {
      navigate({
        pathname: `/clients`,
        search: `?screen=details&id=${clientId}&tab=contracts`,
      });
    } else if (type === NOTIFICATION_TYPE.APPOINTMENT_REQUEST) {
      navigate({
        pathname: `/clients`,
        search: `?screen=details&id=${clientId}&tab=appointments`,
      });
    }
  };

  //const totalPages = Math.ceil(total / perPage);

  return (
    <Container>
      <Sidebar />
      <HamburgerSidebar />
      <ContentContainer>
        <Header title={'Notifications'} />
        {/* {!getAllNotificationsPending ? (
          !data?.length ? (
            <InboxContainer $empty>
              <NoDataTitle>You don't have notifications yet.</NoDataTitle>
            </InboxContainer>
          ) : (
            <>
              <TableContainer>
                <StyledTable>
                  <thead>
                    <tr>
                      <th></th>
                      <StyledTh></StyledTh>
                      <StyledTh></StyledTh>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item, key) => {
                      return (
                        <tr key={key}>
                          <StyledTdAll>
                            <TableRow>
                              <IconDiv>
                                `
                                {(item.type === NOTIFICATION_TYPE.PAYMENT_CREATED && <Payment />) ||
                                  (item.type === NOTIFICATION_TYPE.REQUEST_SENT && <Customer />) ||
                                  (item.type === NOTIFICATION_TYPE.APPOINTMENT_CREATED && <Appointment />)}
                              </IconDiv>
                              {item.title} - {item.description}`
                            </TableRow>
                          </StyledTdAll>

                          <LastTableItem>
                            {(item.type === NOTIFICATION_TYPE.REQUEST_SENT &&
                              item.data.status === NOTIFICATION_STATUS.PENDING) ||
                            (item.type === NOTIFICATION_TYPE.PAYMENT_CREATED &&
                              item.data.status === NOTIFICATION_STATUS.PENDING) ||
                            (item.type === NOTIFICATION_TYPE.APPOINTMENT_REQUEST &&
                              item.data.status === NOTIFICATION_STATUS.PENDING) ? (
                              <>
                                {clickedItemId === item.id &&
                                (acceptClientRequestPending ||
                                  rejectClientRequestPending ||
                                  acceptClientAppointmentPending ||
                                  acceptClientPaymentRequestPending) ? (
                                  <Waveform size={20} lineWeight={3.5} speed={1} color="black" />
                                ) : (
                                  <Buttons>
                                    <ButtonReject
                                      onClick={() => {
                                        handleRejectRequest(item.data.weddingVendorId, item.id);
                                      }}>
                                      Reject
                                    </ButtonReject>
                                    <ButtonAccept
                                      onClick={() => {
                                        item.type === NOTIFICATION_TYPE.REQUEST_SENT &&
                                          handleAcceptRequest(item.data.weddingVendorId, item.id);
                                        item.type === NOTIFICATION_TYPE.PAYMENT_CREATED &&
                                          handleAcceptPayment(item.id, item.data.paymentId);
                                        item.type === NOTIFICATION_TYPE.APPOINTMENT_REQUEST &&
                                          handleAcceptAppointment(item.data.appointmentId, item.id);
                                      }}>
                                      Accept
                                    </ButtonAccept>
                                  </Buttons>
                                )}
                              </>
                            ) : (
                              <>
                                {item.type === NOTIFICATION_TYPE.REQUEST_SENT &&
                                item.data.status === NOTIFICATION_STATUS.REJECTED ? (
                                  <RejectedTitle>Rejected </RejectedTitle>
                                ) : (
                                  <RightChevron
                                    className="icon-add"
                                    onClick={() => handleNavigate(item.type, item.data?.senderId)}
                                  />
                                )}
                              </>
                            )}
                          </LastTableItem>
                        </tr>
                      );
                    })}
                  </tbody>
                </StyledTable>
              </TableContainer>
              {totalPages === 1 && <div style={{ marginBottom: 40 }} />}
              {totalPages !== 1 && (
                <PageCountContainer>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <PageButton
                      key={index}
                      onClick={() => changePage(index + 1)}
                      style={{
                        backgroundColor: +pageParam === index + 1 ? '#f5edef' : 'transparent',
                        borderRadius: +pageParam === index + 1 ? '50%' : 0,
                        border: +pageParam === index + 1 ? '1px solid #000' : '1px solid transparent',
                      }}>
                      {index + 1}
                    </PageButton>
                  ))}
                </PageCountContainer>
              )}
            </>
          )
        ) : (
          <InboxContainer $empty>
            <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
          </InboxContainer>
        )} */}

        {!getAllNotificationsPending ? (
          data.length ? (
            <Table
              totalCount={total}
              currentPage={+pageParam}
              setPage={changePage}
              perPage={perPage}
              noDataContent="No data"
              dataLoading={false}
              lastColumnAligned
              minHeight={697}>
              {data.map(item => (
                <TableBodyRow
                  key={item.id}
                  onClick={() =>
                    item.data.status !== NOTIFICATION_STATUS.PENDING && handleNavigate(item.type, item.data?.senderId)
                  }>
                  <FirstItem
                    data={
                      <>
                        <IconDiv>
                          {(item.type === NOTIFICATION_TYPE.PAYMENT_CREATED && <Payment />) ||
                            ((item.type === NOTIFICATION_TYPE.REQUEST_SENT ||
                              item.type === NOTIFICATION_TYPE.REQUEST_ACCEPTED ||
                              item.type === NOTIFICATION_TYPE.REQUEST_REJECTED) && <Customer />) ||
                            ((item.type === NOTIFICATION_TYPE.APPOINTMENT_CREATED ||
                              item.type === NOTIFICATION_TYPE.APPOINTMENT_REQUEST ||
                              item.type === NOTIFICATION_TYPE.APPOINTMENT_DELETED) && <Appointment />)}
                        </IconDiv>
                        {item.title}
                      </>
                    }
                  />

                  <TableItemCenter
                    $long
                    data={item?.description?.length > 70 ? item?.description?.slice(0, 70) + '...' : item?.description}
                  />

                  <LastTableItem
                    data={
                      <>
                        {(item.type === NOTIFICATION_TYPE.REQUEST_SENT &&
                          item.data.status === NOTIFICATION_STATUS.PENDING) ||
                        (item.type === NOTIFICATION_TYPE.PAYMENT_CREATED &&
                          item.data.status === NOTIFICATION_STATUS.PENDING) ||
                        (item.type === NOTIFICATION_TYPE.APPOINTMENT_REQUEST &&
                          item.data.status === NOTIFICATION_STATUS.PENDING) ||
                        (item.type === NOTIFICATION_TYPE.DELETE_WEDDING_VENDOR &&
                          item.data.status === NOTIFICATION_STATUS.PENDING) ? (
                          <>
                            {clickedItemId === item.id &&
                            (acceptClientRequestPending ||
                              rejectClientRequestPending ||
                              acceptClientAppointmentPending ||
                              acceptClientRequestPaymentPending ||
                              rejectClientRequestPaymentPending ||
                              rejectClientAppointmentPending ||
                              acceptClientDeleteRequestPending ||
                              rejectContractDeleteRequestPending) ? (
                              <Waveform size={20} lineWeight={3.5} speed={1} color="black" />
                            ) : (
                              <Buttons>
                                <ButtonReject
                                  onClick={() => {
                                    item.type === NOTIFICATION_TYPE.REQUEST_SENT &&
                                      handleRejectRequest(item.data.weddingVendorId, item.id);
                                    item.type === NOTIFICATION_TYPE.PAYMENT_CREATED &&
                                      handleRejectPayment(item.id, item.data.paymentId);
                                    item.type === NOTIFICATION_TYPE.APPOINTMENT_REQUEST &&
                                      handleRejectAppointment(item.data.appointmentId, item.id);
                                    item.type === NOTIFICATION_TYPE.DELETE_WEDDING_VENDOR &&
                                      handleRejectDeleteRequest(item.id);
                                  }}>
                                  Reject
                                </ButtonReject>
                                <ButtonAccept
                                  onClick={() => {
                                    item.type === NOTIFICATION_TYPE.REQUEST_SENT &&
                                      handleAcceptRequest(item.data.weddingVendorId, item.id);
                                    item.type === NOTIFICATION_TYPE.PAYMENT_CREATED &&
                                      handleAcceptPayment(item.id, item.data.paymentId);
                                    item.type === NOTIFICATION_TYPE.APPOINTMENT_REQUEST &&
                                      handleAcceptAppointment(item.data.appointmentId, item.id);
                                    item.type === NOTIFICATION_TYPE.DELETE_WEDDING_VENDOR &&
                                      handleAcceptDeleteRequest(item.data.senderId, item.id);
                                  }}>
                                  Accept
                                </ButtonAccept>
                              </Buttons>
                            )}
                          </>
                        ) : (
                          <>
                            {(item.type === NOTIFICATION_TYPE.REQUEST_SENT &&
                              item.data.status === NOTIFICATION_STATUS.REJECTED) ||
                            item.type === NOTIFICATION_TYPE.REQUEST_REJECTED ||
                            (item.type === NOTIFICATION_TYPE.DELETE_WEDDING_VENDOR &&
                              item.data.status === NOTIFICATION_STATUS.REJECTED) ? (
                              <RejectedTitle>Rejected </RejectedTitle>
                            ) : (
                              item.type !== NOTIFICATION_TYPE.ACCEPTED_DELETE_WEDDING_VENDOR && (
                                <RightChevron className="icon-add" />
                              )
                            )}
                          </>
                        )}
                      </>
                    }
                  />
                </TableBodyRow>
              ))}
            </Table>
          ) : (
            <InboxContainer $empty>
              <NoDataTitle>You don't have notifications yet.</NoDataTitle>
            </InboxContainer>
          )
        ) : (
          <InboxContainer $empty>
            <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
          </InboxContainer>
        )}
      </ContentContainer>
    </Container>
  );
};

export default NotificationsPage;
